/**
 * US Employer Identification Number (EIN) validator.
 * Format: XX-XXXXXXX (9 digits). The field is optional, so an empty value is valid.
 */
export const validateEIN = (ein) => {
  if (!ein || String(ein).trim() === '') return true;
  const value = String(ein).trim();
  if (!/^\d{2}-\d{7}$/.test(value)) return false;
  // "00" is never an IRS-assigned prefix
  return !value.startsWith('00');
};

/**
 * Format EIN while typing: digits only, max 9 digits, auto-insert hyphen after the 2nd digit.
 */
export const formatEIN = (value) => {
  if (!value && value !== 0) return '';
  const digits = String(value).replace(/\D/g, '').slice(0, 9);
  if (digits.length <= 2) return digits;
  return `${digits.slice(0, 2)}-${digits.slice(2)}`;
};
